import { getPartnerFlagsById } from 'legacy/lut/features/partner/api'
import { selectPartnerFlags } from 'legacy/lut/features/partner/selectors'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'

export const useGetPartnerFlags = (partnerId: string, options?: ICrudFetchOptions) => {
  const dispatch = useAppDispatch()
  const { accreditation, program, agreement, status, message } = useSelector(
    selectPartnerFlags,
    shallowEqual
  )

  useEffect(() => {
    dispatch(getPartnerFlagsById({ partnerId, options }))
  }, [partnerId, dispatch, options])

  return { accreditation, agreement, program, status, message }
}
